import { sortReplies, formatDate } from '@btime/helpers'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGroupedRepliesByCategory } from '../../../../containers/dynamic/presentationList/categories/_data/groupByCategories'
import { usePdfOptionsForm } from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import RepliesSection from '../replies/RepliesSection'
import Separator from '../../../../components/pdf/Separator'
import ServiceOrderHeader from '../general/ServiceOrderHeader'
import View from '../../../../components/pdf/View'
import LabelValue from '../../../../components/pdf/LabelValue'

const CustomOverview = ({ serviceOrder, form }) => {
  const { t } = useTranslation('serviceOrders')
  return (
    <div>
      {form.showChildrenActive && serviceOrder.asset && <LabelValue label={t('show.asset')} value={serviceOrder.asset.name} />}
      {form.showChildrenQuestionnaire && serviceOrder.checklist?.name && (
        <LabelValue label={t('show.checklist')} value={serviceOrder.checklist.name} />
      )}
      {form.showChildrenDestination && serviceOrder.place && (
        <LabelValue
          label={t('bulkEdit.fields.place')}
          value={serviceOrder.place.resume + ' - ' + serviceOrder.place?.name}
        />
      )}
      {form.showChildrenCheckIn && (
        <LabelValue label={t('fields.checkIn')} value={formatDate('DD/MM/YYYY HH:mm', serviceOrder.startDate || '')} />
      )}
      {form.showChildrenCheckOut && (
        <LabelValue label={t('fields.checkOut')} value={formatDate('DD/MM/YYYY HH:mm', serviceOrder.endDate || '')} />
      )}
      <LabelValue label={t('interpolations.groups.activity')} value={serviceOrder.yearlyId} />
    </div>
  )
}

const ChildrenRepliesSection = ({ serviceOrder }) => {
  const replies = sortReplies(serviceOrder.replies)
  const categories = useGroupedRepliesByCategory(sortReplies(replies))
  const form = usePdfOptionsForm()

  return (
    <View noWrap>
      <Separator weight={20} />
      <ServiceOrderHeader serviceOrder={serviceOrder} />
      <CustomOverview serviceOrder={serviceOrder} form={form} />
      <RepliesSection serviceOrder={serviceOrder} categories={categories} />
    </View>
  )
}

export default ChildrenRepliesSection
